import React from 'react';
import { COLORS, Image, ImageEntity, SIZES, Typography } from '@fupa/fupa-uikit';
import { getTeamName } from 'app/helpers/getTeamName';
import MatchResult from 'app/components/match/liveResult/MatchResult';
import styled from 'styled-components';
export const Container = styled.div.withConfig({
  componentId: "sc-qv8xbg-0"
})(["display:grid;grid-template-columns:1fr 6.75rem 1fr;justify-items:center;min-height:", ";"], SIZES['42']);
const Team = styled.div.withConfig({
  componentId: "sc-qv8xbg-1"
})(["display:grid;justify-items:center;justify-content:center;align-content:start;"]);
const TeamName = styled(Typography).withConfig({
  componentId: "sc-qv8xbg-2"
})(["&&&{color:", ";}display:block;line-height:", ";width:100%;overflow:hidden;text-overflow:ellipsis;text-align:center;white-space:nowrap;"], COLORS.black, SIZES['24']);
export default function UpdateResultHeader(_ref) {
  let {
    match,
    resultData
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "UpdateResultHeader",
    "data-sentry-source-file": "UpdateResultHeader.tsx"
  }, /*#__PURE__*/React.createElement(Team, {
    "data-sentry-element": "Team",
    "data-sentry-source-file": "UpdateResultHeader.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Emblem,
    height: 64,
    width: 64,
    src: match.homeTeam.image,
    fit: true,
    alt: match.homeTeamName,
    "data-sentry-element": "Image",
    "data-sentry-source-file": "UpdateResultHeader.tsx"
  }), /*#__PURE__*/React.createElement(TeamName, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "TeamName",
    "data-sentry-source-file": "UpdateResultHeader.tsx"
  }, getTeamName(match.homeTeam.name.middle, match.homeTeam.level))), /*#__PURE__*/React.createElement(MatchResult, {
    data: resultData,
    "data-sentry-element": "MatchResult",
    "data-sentry-source-file": "UpdateResultHeader.tsx"
  }), /*#__PURE__*/React.createElement(Team, {
    "data-sentry-element": "Team",
    "data-sentry-source-file": "UpdateResultHeader.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Emblem,
    height: 64,
    width: 64,
    src: match.awayTeam.image,
    fit: true,
    alt: match.awayTeamName,
    "data-sentry-element": "Image",
    "data-sentry-source-file": "UpdateResultHeader.tsx"
  }), /*#__PURE__*/React.createElement(TeamName, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "TeamName",
    "data-sentry-source-file": "UpdateResultHeader.tsx"
  }, getTeamName(match.awayTeam.name.middle, match.awayTeam.level))));
}